import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-blog-digital-transformation',
  imports: [CommonModule, RouterModule],
  standalone: true,
  templateUrl: './blog-digital-transformation.component.html',
  styleUrl: './blog-digital-transformation.component.scss'
})
export class BlogDigitalTransformationComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
      .subscribe((event: any) => {
        if (this.router.url === '/blogs/digital-transformation') {
          this.updateDescription(event.description, event.keywords, event.title);
        }
      });
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const digitalTransformationSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation#webpage",
          "url": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation",
          "name": "Ready to Digitize Your Business Process? Here's What You Need To Know",
          "description": "Comprehensive guide to enterprise digital transformation covering definition, phases, misconceptions, drivers, and benefits.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2023-07-18"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "Blog Index", "item": "https://www.kalpitatechnologies.com/tech-blogs/blog" },
            { "@type": "ListItem", "position": 3, "name": "Digital Transformation", "item": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation" }
          ]
        },
        {
          "@type": "BlogPosting",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation#blogposting",
          "headline": "Ready to Digitize Your Business Process? Here's What You Need To Know",
          "articleBody": "Digital transformation has become a buzzword in the technology world. Enterprise digital transformation leverages digital technologies to optimize end-to-end business processes through two phases...",
          "author": { "@type": "Person", "name": "Grace Catharine" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2023-07-18",
          "image": "https://www.kalpitatechnologies.com/assets/resources/blog/digital-transform/digital-banner.svg"
        },
        {
          "@type": "HowTo",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation#howto",
          "name": "How to Implement Enterprise Digital Transformation",
          "step": [
            { "@type": "HowToStep", "position": 1, "name": "Set Your Goal", "text": "Strategize a goal that empowers your business performance." },
            { "@type": "HowToStep", "position": 2, "name": "Plan of Action", "text": "Analyze mundane manual tasks to be automated." },
            { "@type": "HowToStep", "position": 3, "name": "Choose Technology", "text": "Select the right tool or technology that suits your processes." },
            { "@type": "HowToStep", "position": 4, "name": "Verify Regulations", "text": "Verify company policy for risks and compliance." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/tech-blogs/digital-transformation#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What is the difference between digitization and digitalization?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Digitization is converting physical documents to digital format. Digitalization is transforming business workflows using digital technologies to improve efficiency."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(digitalTransformationSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  updateDescription(desc: string, keywords: string, title: string) {
    // this.seoService.updateDescription(desc);
    // this.seoService.updateMetaKeywords(keywords);
    // this.seoService.updateTitle(title);
  }

}
